import React, { useEffect, useState } from "react";
import ViewTable from "../../../Components/Common/ViewTable";
import { get, post, put, del, api } from "../../../utils/api";
import Cards from "../../../Components/Common/Cards";
import FilterModal from "../../../Components/Common/FilterModal";
import Form from "./Form";
import ActionButtons from "../../../Components/Common/ActionButtons";
import ViewData from "./ViewData.jsx";
import BulkUploadModal from "../../../Components/Common/BulkUploadModal";
import {
  Alert,
  Snackbar,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import { useUser } from "../../../context/AuthContext.js";
import DeleteAlertDialog from "../../../Components/Masters/DeleteAlertDialog.js";

const BusinessTravel = () => {
  const { user } = useUser();
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });
  const [tableData, setTableData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [selectedValue, setSelectedValue] = useState(null);
  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deletedItemId, setDeletedItemId] = useState("");
  const [excelData, setExcelData] = useState(null);
  const [filters, setFilters] = useState({
    origin: [],
    destination: [],
    travelMode: [],
    accommodation: [],
    employeeName: [],
  });

  const [cardData, setCardData] = useState({
    totalTrips: 0,
    topDestination: [],
    popularMode: "",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const headers = [
    { key: "dateOfTravel", label: "Date of Travel", sortable: true },
    { key: "employeeName", label: "Employee Name", sortable: true },
    { key: "origin", label: "Origin Location", sortable: true },
    {
      key: "destination",
      label: "Destination Location",
      sortable: true,
    },
    {
      key: "travelMode",
      label: "Mode of Travel",
      sortable: true,
    },
  ];

  const inputData = [
    {
      fieldName: "dateOfTravel",
      title: "Date of Travel",
    },
    {
      fieldName: "travelType",
      title: "Travel Type",
    },
    {
      fieldName: "employeeName",
      title: "Employee Name",
    },
    {
      fieldName: "employeePosition",
      title: "Employee Position",
    },
    {
      fieldName: "country",
      title: "Travel Location",
    },
    {
      fieldName: "origin",
      title: "Origin Location",
    },
    {
      fieldName: "destination",
      title: "Destination Location",
    },
    {
      fieldName: "distanceCovered",
      title: "Distance (Km)",
    },
    {
      fieldName: "travelMode",
      title: "Travel Mode",
    },
    {
      fieldName: "daysOfHotelStay",
      title: "Nights Stay in Hotel",
    },

    // {
    //   fieldName: "data.roomType",
    //   title: "Class",
    // },
    // {
    //   fieldName: "data.accommodation",
    //   title: "Accommodation",
    // },
    // {
    //   fieldName: "data.country",
    //   title: "Country",
    // },
    // {
    //   fieldName: "data.numberOfNights",
    //   title: "No of Nights Stay",
    // },
  ];

  let bannerData = [
    {
      title: "Total number of Business Trips",
      description: `${cardData?.totalTrips ?? 0} Trips`,
    },
    {
      title: "Top Travel Destination",
      description: cardData?.topDestination ?? [],
    },
    {
      title: "Popular Mode of Travel",
      description: cardData?.popularMode ?? "",
    },
  ];

  const filterData = [
    { title: "Date of Travel", type: "date", key: "dateOfTravel", value: [] },
    {
      title: "Employee",
      type: "option",
      key: "employeeName",
      value: filters?.employeeName,
    },
    {
      title: "Origin Location",
      type: "option",
      key: "origin",
      value: filters?.origin,
    },
    {
      title: "Destination Location",
      type: "option",
      key: "destination",
      value: filters?.destination,
    },
    {
      title: "Travel Mode",
      type: "option",
      key: "travelMode",
      value: filters?.travelMode,
    },
  ];

  const fetchExcelData = async () => {
    const travelTypes = ["Domestic Travel", "International Travel"];
    const allModes = ["Air", "Road", "Rail", "Water"];

    // Define which modes are allowed for each travel type
    const allowedModes = {
      "Domestic Travel": ["Air", "Road", "Rail", "Water"],
      "International Travel": ["Air", "Road", "Rail", "Water"], // Only Air and Water allowed for International
    };

    let arr = [];
    let serialNo = 1;

    // Loop through each mode and generate entries for both travel types
    allModes.forEach((mode) => {
      travelTypes.forEach((travelType) => {
        // Skip if mode is not allowed for this travel type
        if (!allowedModes[travelType].includes(mode)) return;

        arr.push({
          "S No.": serialNo++,
          "Travel Date (DD/MM/YYYY)": "",
          "Employee Name": "",
          "Employee Position": "",
          "Travel Type": travelType,
          "Layover Location,(Separate)": "",
          "Mode of Business Travel": mode,
          Country: "",
          "No. of Night Stay in Hotel": "",
          Origin: "",
          Destination: "",
          "Air Travel Class": "",
          "Distance Cover": "",
          Document: "",
          // Store allowed modes for UI dropdown
        });
      });
    });

    setExcelData(arr);
  };

  useEffect(() => {
    fetchExcelData();
  }, []);

  const fetchData = async () => {
    let filter = { ...filterObj };
    if (filter.load) {
      filter.minLoad = parseInt(filterObj.load.min);
      filter.maxLoad = parseInt(filterObj.load.max);
    }
    if (filter.dateOfTravel) {
      filter.startDate = filter?.dateOfTravel?.start;
      filter.endDate = filter?.dateOfTravel?.end
        ? filter?.dateOfTravel?.end
        : new Date();
    }
    const queryParams = new URLSearchParams({
      ...filter,
      page: currentPage,
      limit: 10,
      sortField: sortConfig.key,
      sortOrder: sortConfig.direction,
    }).toString();
    console.log("first123", filter);
    await get(`/scope3/businessTravelEmissions/get?${queryParams}`)
      .then((res) => {
        console.log(res?.data);
        let arr = res?.data?.data?.map((item) => {
          // For Road, prefer originAddress/destinationAddress if present
          return {
            // dateOfTravel: new Date(item.dateOfTravel).toLocaleDateString(
            //   "en-GB",
            //   {
            //     day: "2-digit",
            //     month: "short",
            //     year: "numeric",
            //   }
            // ),
            employeeName: item?.employeeName,
            origin: item?.origin,
            destination: item?.destination,
            travelMode: item?.travelMode,
            remark: item?.remark,
            action: "View",
            id: item?._id,
            ...item,
          };
        });
        setTableData(arr);
        setTotalPages(res?.data?.totalPages);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchData();
  }, [sortConfig, filterObj, currentPage]);

  const fetchFilters = async () => {
    try {
      const res = await get(`/scope3/businessTravelEmissions/filter`);
      const { origin, destination, travelMode, accommodation, employeeName } =
        res?.data?.data || {};
      setFilters({
        origin: origin || [],
        destination: destination || [],
        travelMode: travelMode || [],
        accommodation: accommodation || [],
        employeeName: employeeName || [],
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchFilters();
  }, []);

  const fetchCardData = async () => {
    try {
      const res = await get(`/scope3/businessTravelEmissions/cardData`);
      setCardData({
        totalTrips: res?.data?.data?.totalTrips,
        topDestination: res?.data?.data?.topDestination.map(
          (item) => item?.destination
        ),
        popularMode: res?.data?.data?.popularMode?.mode,
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchCardData();
  }, []);

  const openModal = (type, dataForEdit) => {
    if (type === "add") {
      setIsModalOpen(true);
    } else if (type === "edit") {
      setIsModalOpen(true);
      dataForEdit.createdAt = dataForEdit?.createdAt.split("T")[0];
      dataForEdit.dateOfTravel = dataForEdit?.dateOfTravel.split("T")[0];
      setEditData(dataForEdit);
      setEditModal(true);
      setViewModal(false);
    }
  };

  const handleEdit = (data) => {
    data.createdAt = data?.createdAt.split("T")[0];
    data.dateOfTravel = data?.dateOfTravel.split("T")[0];
    setIsModalOpen(true);
    setEditData(data);
    setEditModal(true);
    setViewModal(false);
  };

  const openViewModal = (data) => {
    // data.createdAt = data?.createdAt.split("T")[0];
    // data.dateOfTravel = new Date(data?.dateOfTravel).toLocaleDateString(
    //   "en-GB"
    // );
    setEditData(data);
    setViewModal(true);
  };

  const handleSort = (key, direction) => {
    setSortConfig({ key, direction });
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleFilterChange = (newFilterObj) => {
    setFilterObj(newFilterObj);
    setCurrentPage(1);
  };

  const closeModal = (type) => {
    if (type === "add") {
      setIsModalOpen(false);
    } else if (type === "edit") {
      setIsModalOpen(false);
      setEditModal(false);
      setEditData({});
    }
  };

  const handleSubmit = async (data, type) => {
    try {
      if (type) {
        let res = await put(
          `/scope3/businessTravelEmissions/update?Id=${editData._id}`,
          data
        );
        if (res) {
          setsnackOpen({
            open: true,
            message: res.data.message,
            severity: "success",
          });
          setIsModalOpen(false);
          setEditModal(false);
          setEditData({});
          fetchCardData();
        }
      } else {
        let res = await post(`/scope3/businessTravelEmissions/add`, data);
        if (res) {
          setsnackOpen({
            open: true,
            message: res.data.message,
            severity: "success",
          });
          setIsModalOpen(false); // Close modal after successful request
          fetchCardData();
        }
      }

      fetchData(); // Fetch data after modal is closed
    } catch (error) {
      setsnackOpen({
        open: true,
        message: error?.response?.data?.message || "Sommething went wrong",
        severity: "error",
      });
      console.log("Error in handleSubmit:", error.response.data.message);
    }
  };

  const handleSelectChange = (value) => {
    setSelectedValue(value);
  };

  const handleDeleteOpen = (itemId) => {
    setDeletedItemId(itemId);
    setDeleteDialog(true);
  };

  const handleDeleteAggree = async () => {
    await del(`/scope3/businessTravelEmissions/delete`, {
      params: {
        Id: deletedItemId?._id, // Pass as query parameter
      },
    })
      .then(async (res) => {
        setDeleteDialog(false);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        fetchData();
        fetchCardData();
      })
      .catch((err) => {
        console.log(err);
        setsnackOpen({
          open: true,
          message: err.response?.data?.message ?? "Network Error",
          severity: "error",
        });
      });
  };

  return (
    <>
      <Cards
        data={bannerData}
        title={"Business Travel Emission"}
        onFilterChange={handleSelectChange}
      />
      <ActionButtons
        onFilterClick={() => setIsFilterModalOpen(true)}
        onAddClick={() => openModal("add")}
        filterObj={filterObj}
        onUploadClick={() => setBulkUploadModal(true)}
      />

      <ViewTable
        title={"Business Travel Emission"}
        headers={headers}
        data={tableData ?? []}
        onSort={handleSort}
        sortConfig={sortConfig}
        page={currentPage}
        count={pageSize}
        editIcon={user?.companyAdmin ? "disable" : "enable"}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        onView={(row) => {
          openViewModal(row);
        }}
        onEdit={(row) => openModal("edit", row)}
        onDelete={(row) => handleDeleteOpen(row)}
      />
      <Snackbar
        open={snackOpen.open}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setsnackOpen({ ...snackOpen, open: false })}
      >
        <Alert
          onClose={() => setsnackOpen({ ...snackOpen, open: false })}
          severity={snackOpen.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackOpen.message}
        </Alert>
      </Snackbar>

      <Form
        isOpen={isModalOpen}
        onClose={() => closeModal(editModal ? "edit" : "add")}
        onSubmit={handleSubmit}
        header={
          editModal
            ? "Edit Business Travel Emission Data"
            : "Add Business Travel Emission Data"
        }
        initialData={editData}
        isEditing={editModal}
      />

      {/* <View
        isOpen={viewModal}
        onClose={() => setViewModal(false)}
        header={"View Data"}
        initialData={editData}
        handleEdit={(row) => openModal("edit", row)}
      /> */}

      <ViewData
        id={editData ? editData._id : ""}
        element={editData}
        title={"Emissions"}
        viewData={viewModal}
        setViewData={setViewModal}
        setData={setEditData}
        inputData={inputData}
        handleEdit={handleEdit}
        companyAdmin={user?.companyAdmin}
      />

      {/* <DeleteModal
        onOpen={isDeleteDialogOpen}
        onClose={handleDelete}
        url={`/scope3/businessTravelEmissions/delete?Id=${deletedItemId}`}
        deletedItemId={deletedItemId}
      /> */}
      {/* {deleteDialog && (
        <Dialog open={deleteDialog}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Do you really want to delete this entry?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDeleteDialog(false)} color="primary">
              Cancel
            </Button>
            <Button onClick={handleDeleteAggree} color="secondary">
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      )} */}
      {deleteDialog && (
        <DeleteAlertDialog
          {...{
            deleteDialog,
            setDeleteDialog,
            method: "delete",
            id: deletedItemId?._id,
            url: `${api}/scope3/businessTravelEmissions/delete`,
            setsnackOpen,
            fetchData,
            fetchCardData,
          }}
        />
      )}

      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        filters={filterData}
        onFilterChange={handleFilterChange}
        title="Filter"
      />

      {bulkUploadModal && (
        <BulkUploadModal
          onCloseBulkUpload={() => {
            setBulkUploadModal(false);
            fetchData();
          }}
          isBulkUploadModal={bulkUploadModal}
          excelData={excelData}
          fileName={"businessTravel"}
          setsnackOpen={setsnackOpen}
          url={"/scope3/businessTravelEmissions/bulkupload"}
        />
      )}
    </>
  );
};

export default BusinessTravel;
